import { TEXT_DISABLED, FONT_TINY } from '../../theme';
import Tooltip from './Tooltip';

const INFO_ICON_STYLE = {
  ...FONT_TINY,
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
  width: 14, height: 14, borderRadius: '50%',
  border: `1px solid ${TEXT_DISABLED}`, color: TEXT_DISABLED,
  cursor: 'default', userSelect: 'none',
  fontWeight: 700, lineHeight: 1, textTransform: 'none',
  marginLeft: '0.35rem', verticalAlign: 'middle',
};

export default function InfoBadge({ text }) {
  return (
    <Tooltip text={text}>
      <span style={INFO_ICON_STYLE}>i</span>
    </Tooltip>
  );
}
